import {ListPatientsInput, queries} from '@cypro/engine/queries'
import {useQuery} from '@rocicorp/zero/react'

export function useGetGlobalSearchPatients({
  sort = {dir: 'desc', field: 'createdAt'},
  filters,
  limit,
}: Omit<Partial<ListPatientsInput>, 'cursor'> = {}) {
  const query = queries.patients.listGlobalSearchPatients({
    sort,
    filters,
    limit,
  })

  const [patients, meta] = useQuery(query)

  return {
    query,
    meta,
    patients,
    canFetchMore: patients.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
